import TenantNotFound from "./TenantNotFound";
export default TenantNotFound;
